import StageType from "../enums/StageType";
import { getCurrentPerformanceLevelSync } from "../../utils/performance";
import { SettingsStorageService } from "../../services/LocalStorageService";
import { DEFAULT_CHARACTER_ID } from "./character/Character";

export default class PlayerOptions {
  RunCoins: number;
  Runenemies: number;
  SelectedStage: StageType;
  SelectedHyper: boolean;
  RunEnemies: number;
  LifetimeSurvived: number;
  SoundsEnabled: boolean;
  MusicEnabled: boolean;
  FlashingVFXEnabled: boolean;
  JoystickVisible: boolean;
  DamageNumbersEnabled: boolean;
  CheatCodeUsed: boolean;
  BoughtPowerups: any[];
  CollectedWeapons: any[];
  UnlockedWeapons: any[];
  CollectedItems: any[];
  Achievements: any[];
  UnlockedStages: any[];
  UnlockedHypers: any[];
  KillCount: {};
  PickupCount: {};
  DestroyedCount: {};
  SelectedCharacterId: string;

  constructor() {
    this.SelectedCharacterId = DEFAULT_CHARACTER_ID;
    this.SelectedStage = StageType.DESERT1;
    this.SelectedHyper = false;
    this.RunCoins = 0;
    this.RunEnemies = 0;
    this.LifetimeSurvived = 0;
    // Load persisted settings with safe defaults
    this.SoundsEnabled = SettingsStorageService.isSoundsEnabled();
    this.MusicEnabled = SettingsStorageService.isMusicEnabled();
    this.FlashingVFXEnabled = true;
    this.JoystickVisible = false;

    // Set damage numbers based on device performance (read once at initialization)
    const performanceLevel = getCurrentPerformanceLevelSync();
    this.DamageNumbersEnabled = performanceLevel !== "low";

    if (performanceLevel === "low") {
      console.log(
        "Damage numbers disabled for low-tier device performance optimization"
      );
    }

    this.CheatCodeUsed = false;
    this.BoughtPowerups = new Array();
    this.CollectedWeapons = new Array();
    this.UnlockedWeapons = new Array();
    this.CollectedItems = new Array();
    this.Achievements = new Array();
    this.UnlockedStages = new Array();
    this.UnlockedHypers = new Array();
    this.KillCount = {};
    this.PickupCount = {};
    this.DestroyedCount = {};
  }

  Load() {
    // todo: load player options from local storage
  }

  AddCoins(value: number) {
    this.RunCoins += value;
  }
}
